import { z } from 'zod';
import { emailSchema, nameSchema, phoneSchema } from '../../../../helpers/utils/validation';

export const medicalDebtQuizPersonalInfoSchema = z.object({
    firstName: nameSchema,
    lastName: nameSchema,
    email: emailSchema,
    phone: phoneSchema,
});
